import { ref } from 'vue'
import { db } from '@/firebaseConfig'

export default function useDocument(collection, id) {
  let error = ref(null)
  let isPending = ref(false)

  let docRef = db.collection(collection).doc(id)

  const updateDoc = async (updates) => {
    isPending.value = true
    error.value = null

    try {
      const res = await docRef.update(updates)
      isPending.value = false
      return res
    }
    catch (err) {
      console.error(err.message)
      isPending.value = false
      error.value = 'could not update the document'
    }
  }

  return { error, isPending, updateDoc }
}
